module.exports = __webpack_public_path__ + "static/media/team-kori-ann.0f159580.jpg";